import { jsx as s } from "react/jsx-runtime";
import t from "classnames";
const l = ({
  as: n,
  children: i,
  className: o,
  ...r
}) => /* @__PURE__ */ s(n ?? "div", { className: t("visually-hidden", o), ...r, children: i });
export {
  l as V
};
//# sourceMappingURL=VisuallyHidden-42oizZZl.js.map
